<template>
<div>
  <v-dialog v-model="active" width="600">
    <v-card>
      <v-card-title>
        <b>{{department.id > 0 ?   `${$t('department.edit')}  ${department.name}:`  : $t('department.creating') }} </b>
      </v-card-title>
      <v-divider />
      <v-layout>
        <v-container>
          <v-flex xs8>
            <v-text-field v-model="name" :rules="nameRules" :label="`${$t('department.name')}`" required></v-text-field>
          </v-flex>
          <v-flex xs8>
            <v-text-field v-model="description" :label="`${$t('department.description')}`"></v-text-field>
          </v-flex>
          <v-btn @click="emitChanges()">
            {{$t('department.submit')}}
          </v-btn>
        </v-container>
      </v-layout>
    </v-card>
  </v-dialog>
  <slot name='activator' v-bind:on="{click: this.open}">
    <v-btn small icon>
      <v-icon small fab block color="green darken-2" @click="(active = !active)" style="color: #efefef">edit</v-icon>
    </v-btn>
  </slot>
</div>
</template>
<script>
export default {
  props: {
    department: {
      type: Object,
      default: () => ({
        'name': '',
        'description': ''
      })
    }
  },
  computed: {
    options() {
      return {
        theme: {
          mode: this.$store.getters.darkTheme ? 'dark' : 'light'
        },
      }
    },
  },
  data() {
    return {
      name: "",
      description: "",
      active: false,
      nameRules: [
        v => !!v || this.$t('validator.blank'),
        v => !!v && (v.length <= 100 && v.length > 2) || this.$t('validator.wrong_length'),
      ],
    }
  },
  methods: {
    open() {
      this.active = true
    },
    emitChanges() {
      let model = {
        'name': this.name,
        'description': this.description
      }

      let action = 'create'
      if (this.department.id > 0) {
        action = 'update'
        model.id = this.department.id
      }
      this.$emit(action, model)
      this.active = false
    }
  },
  created() {
    this.name = this.department.name
    this.description = this.department.description
  }
}
</script>

<style>

</style>
